import React, { memo } from "react";
import Buttons from "../../../../../../components/ui/button/Buttons";
import { buildFieldKey } from "../utils/buildFieldKey";
import FieldRow from "./FieldRow";
import HtmlContent from "./HtmlContent";

const EMPTY = [];

const RequirementCard = ({
    reqId,
    item,
    reqState,
    fields,
    fieldValues,
    brandList,
    isSaving,
    onCommentChange,
    onSave,
    className = "",
}) => {
    const files = reqState?.files ?? EMPTY;
    const hasBrands = brandList?.length > 0;

    const rows = fields.flatMap((field) =>
        (hasBrands ? brandList : [null]).map((brand) => {
            const key = buildFieldKey(field.sgbpAdditionalFieldInputId, brand?.id ?? null);
            return <FieldRow key={key} field={field} brand={brand} fieldState={fieldValues[key]} />;
        })
    );

    return (
        <div className={`evaluation-table ${className}`.trim()}>
            <div className="table-header">
                <div>{item.requirementName}</div>
                <div>Documents to Upload</div>
                <div>Submission</div>
            </div>

            <div className="table-body">
                <HtmlContent className="column instruction-content" html={item.requirementDescription} />
                <HtmlContent className="column instruction-content" html={item.requirementToBeSubmitted} />

                <div className="column submission">

                    <span style={{ color: "#f52828", fontSize: "18px", display: "block", marginBottom: "6px" }}>
                        🔒 This requirement is locked.
                    </span>

                    <div className="files">
                        {files.map((f) => (
                            <p key={f.id} className="file-item">
                                <span className="file-name" style={{ cursor: "not-allowed" }}>
                                    {f.name}
                                </span>
                                <span className="delete-file" style={{ cursor: "not-allowed" }}>
                                    Delete
                                </span>
                            </p>
                        ))}
                    </div>

                    <label>Comment</label>
                    <textarea disabled value={reqState?.comment || ""} />
                </div>

                {rows.length > 0 &&
                    (hasBrands ? (
                        rows
                    ) : (
                        <div className="row">
                            <div className="form-block">{rows}</div>
                        </div>
                    ))}
            </div>

            <div className="status-bar">
                <span>Status</span>
                <span>{reqState?.status || ""}</span>
                <span></span>
            </div>

            {/* <div className="commant-box">
                <label>Case Officer Clarification Comments (External)</label>
                <textarea disabled placeholder="SGBC Comments" value={reqState?.caseOfficerComments || ""} />
            </div> */}

            <div className="commant-box pt-0">
                <label>Peer Reviewer/Final Approver Comments (Internal)</label>
                <textarea
                    disabled
                    placeholder="SGBC Comments"
                    value={reqState?.peerReviewerComments || ""}
                    onChange={(e) => onCommentChange(reqId, e.target.value)}
                />
            </div>
        </div>
    );
};

export default memo(RequirementCard);